<template lang="html">
  <div class="not-found">
    <img :src="$store.state.static_img_url+'mobile/pic/404.png'">
    <p>抱歉！您访问的页面不存在</p>
    <div @click="backMain">
      返回首页
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    backMain() {
      window.location.href = this.$store.state.index2_path
    }
  }
}
</script>
<style lang="stylus" scoped>
.not-found
  text-align: center;
  img
    height: 5.05rem
  p
    margin-top: .4rem;
    font-size: .36rem;
    color: #333333;
  div
    margin-left: auto;
    margin-right: auto;
    margin-top: .42rem;
    background-image: linear-gradient(146deg, #FFA337 0%, #FF8824 100%);
    box-shadow: 0 8px 16px 0 rgba(76,58,23,0.15);
    border-radius: .52rem;
    width: 3.2rem;
    height: 1rem;
    font-size: .34rem;
    color: #FFFFFF;
    text-align: center;
    line-height: 1rem
</style>
